import Gallery from "../components/gallery";
import Speakers from "../components/speakers";
import Hero from "../components/hero";
import BlogSection from  '../components/blogSection'
import RegisterSection from "../components/registerSection";
import BoxMedia from "./boxmedia";
import Partners from './partners'
import Subscriber from './subscriber'
import Footer from './footer'
import TweetList from './tweetlist'
import About from './about';
import CountdownCard from "./countdownCard";

const Home = () => {
  return (
    <div>
      <Hero />
  
      <RegisterSection/>
      <Gallery/>
      <TweetList/>
      <Partners/>
      <Footer/> 

      {/* 
      
      <BlogSection/>
      
      <TweetList/>
      <Partners/>
      <Footer/>  */}
     
    </div>
  );
};

export default Home;
